import React from 'react';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { map } from 'lodash';
import classnames from 'classnames';
import { Icon } from 'modules/icon-bank';

import { widgetPreloader as WidgetPreloader } from 'ui/views/generic/widgetPreloader';
import { WIDGET_NAMES } from 'constants/entity-names';
import { getLabel } from 'utils/getLabel';
import { layoutConfig } from 'config/table-configs/call-list';

// widget views
import { CallWidgetItemDetailSummary } from 'ui/containers/CallWidgetItemDetailSummary';
import { CallItemDetailInnerTab } from 'ui/containers/CallItemDetailInnerTab';

import { CallItemNotesWidget } from 'ui/containers/CallItemNotesWidget';

const WIDGET_VIEWS = {
    [ WIDGET_NAMES.CALL_DETAIL_SUMMARY ]: CallWidgetItemDetailSummary,
    [ WIDGET_NAMES.CALL_DETAIL_TABS ]: CallItemDetailInnerTab,

    [ WIDGET_NAMES.CALL_ITEM_NOTES ]: CallItemNotesWidget,
};

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { callWidgetItemDetail as CallWidgetItemDetail } from 'ui/views/callWidgetItemDetail';
 *
 * // render
 * <CallWidgetItemDetail propName='propValue'/>
 */
export const callWidgetItemDetail = ( props ) => {
    return (
        <div className='ui-call-widget-item-detail'>
              <div className='ui-call-widget-item-detail__action'>
                {
                    map( props.navActions, navAction => {

                        // get the action for navAction
                        const icondId = 'back' === navAction.name ? 'backArrow': null;

                        return (
                            <div className='ui-call-widget-item-detail__action__navaction' key={ navAction.name }
                                onClick={ () => props.onNavActionClick( { type: 'headerAction', value: navAction } ) }
                            >
                                <Icon id={ icondId } />
                                <div className='ui-call-widget-item-detail__action__navaction__label'>{ getLabel( navAction.title ) }</div>
                            </div>
                        );

                    } )
                }
            </div>

            <div className='ui-call-widget-item-detail'>
                {
                    map( props.widgets, ( widget, widgetIndex ) => {

                        // get widget view
                        const WidgetView = WIDGET_VIEWS[ widget.name ];

                        const widgetClassName = classnames( 'ui-call-widget-item-detail__widget', `ui-call-widget-item-detail__widget--name-${ widget.name }` );
    
                        return (
                            <div key={ widgetIndex } className={ widgetClassName }>
                                <WidgetView
                                    widget={ widget }
                                    callId={ props.callId }
                                    requestPayload={ props.requestPayload }
                                    layoutConfig={ {...layoutConfig, dimension: { maxHeight: layoutConfig.maxHeight, padding: 10 }} }
                                />
                            </div>
                        );
                    } )
                }
                
            </div>

        </div>
    );
};

// set display name
callWidgetItemDetail.displayName = 'callWidgetItemDetail';

// set default props
callWidgetItemDetail.defaultProps = {};

// prop types
callWidgetItemDetail.propTypes = {};


// preloader view
export const callWidgetItemDetailPreloader = () => {
    return (
        <div className='ui-call-widget-item-detail-preloader'>
            <WidgetPreloader />
        </div>
    );
};

// set display name
callWidgetItemDetailPreloader.displayName = 'callWidgetItemDetailPreloader';

// set default props
callWidgetItemDetailPreloader.defaultProps = {};

// prop types
callWidgetItemDetailPreloader.propTypes = {};

export const callWidgetItemDetailView = withNetworkState( callWidgetItemDetailPreloader, callWidgetItemDetail );
